import * as $ from 'jquery';
import store from '../../js/store';

const $firefishMeta = $('.firefish-meta');

let $metaParent,
    pageNavOffset,
    headerHeight,
    isSticky = false,
    windowSize;

if($firefishMeta.length > 0) {

  $metaParent = $firefishMeta.parent();

  $(window).on("load resize",() => {
    reset();

    windowSize = document.body.offsetWidth;

    pageNavOffset = $firefishMeta.offset().top;
    headerHeight = $('#site-head').outerHeight() + ($('#wpadminbar').length > 0 ? $('#wpadminbar').outerHeight() : 0);

    $(window).scroll();
  });

  $(window).on("scroll",() => {

    if($(window).scrollTop() > pageNavOffset - headerHeight && windowSize >= parseInt(store.constants['sprout-breakpoints'].large)) {

        set(headerHeight);

    } else {

        reset();

    }

  });
}


const reset = (function() {
  $firefishMeta.css({
    position: '',
    top: '',
    left: '', right: '',
    'z-index': '',
  }).removeClass('sticky');

  $metaParent.css('padding-top', '');

  isSticky = false;
});

const set = (function(top = 0) {
  if(!isSticky) {

    $firefishMeta.css({
      position: 'fixed',
      top,
      left: 0, right: 0,
      'z-index': 8000,
    }).addClass('sticky');

    $metaParent.css('padding-top', $firefishMeta.outerHeight()+'px');

    isSticky = true;
  }
});
